import FingerprintJS from "@fingerprintjs/fingerprintjs";

const getFingerprint = async (): Promise<string> => {
  const { visitorId } = await FingerprintJS.load().then((agent) => agent.get());
  return visitorId;
};

export default getFingerprint;
